import titlesRu from './findingTitles.ru.json'

export type Locale = 'ru' | 'en'

const TITLES = titlesRu as Record<string, string>

const TITLE_PREFIXES = Object.entries(TITLES).sort((a, b) => b[0].length - a[0].length)

const REGEX: Array<[RegExp, string]> = [
  [/Long Method: (.+) \((\d+) lines\)/g, 'Длинный метод: $1 ($2 строк)'],
  [
    /Function\/method '(.+)' is (\d+) lines long, exceeding recommended maximum of (\d+) lines\./g,
    'Функция «$1» занимает $2 строк — больше рекомендованных $3.',
  ],
  [/High Cyclomatic Complexity: (.+) \(complexity=(\d+)\)/g, 'Высокая цикломатическая сложность: $1 (сложность $2)'],
  [
    /Function\/method '(.+)' has cyclomatic complexity of (\d+), exceeding threshold\. High complexity makes code harder to understand, test, and maintain\./g,
    'У функции «$1» цикломатическая сложность $2 — выше порога. Такой код сложнее читать, тестировать и сопровождать.',
  ],
  [
    /Code Duplication: (\d+) instances \((\d+) tokens, (\d+)% similar\)/g,
    'Дублирование кода: $1 мест ($2 токенов, сходство $3%)',
  ],
  [/Duplicate code detected across (\d+) locations:/g, 'Один и тот же код найден в $1 местах:'],
  [/Exposed ([^:\n]+): /g, 'Утечка $1: '],
  [/Potential ([^\n]+) detected in source code\./g, 'В исходниках похоже на $1.'],
  [/SQL Injection at /g, 'SQL-инъекция: '],
  [/Cross-Site Scripting \(XSS\) at /g, 'Межсайтовый скриптинг (XSS): '],
  [/Command Injection at /g, 'Инъекция команды: '],
  [/Path Traversal at /g, 'Обход пути: '],
  [/Insecure Deserialization at /g, 'Небезопасная десериализация: '],
  [/Weak Cryptography at /g, 'Слабая криптография: '],
  [/Hardcoded Credentials at /g, 'Зашитые учётные данные: '],
  [/Endpoint missing authentication: /g, 'Эндпоинт без аутентификации: '],
  [/Failed to parse API specification: /g, 'Не разобрали спецификацию API: '],
  [/Frontend Application Unreachable/g, 'Фронт недоступен'],
]

const PHRASES: Array<[string, string]> = [
  ['Location: ', 'Место: '],
  ['Detector: ', 'Детектор: '],
  ['Preview: ', 'Превью: '],
  ['Obsolete crypto is breakable with modest resources.', 'Устаревшую криптографию ломают даже при умеренных ресурсах.'],
  ['Use modern AEAD and password KDFs.', 'Используйте современный AEAD и KDF для паролей.'],
  ['Use modern AEAD.', 'Используйте современный AEAD.'],
  ['Use password KDFs.', 'Используйте KDF для паролей.'],
  ['Anyone with the image can log in as you.', 'Любой, у кого есть образ, сможет войти под вами.'],
  ['Break down into smaller, focused functions. ', 'Разбейте на более короткие функции. '],
  ['Extract logical sections into separate methods.', 'Вынесите логические куски в отдельные методы.'],
  ['Refactor into smaller functions. ', 'Разбейте на более короткие функции. '],
  [
    'Extract logical units into separate methods. Simplify conditional logic.',
    'Вынесите логические куски в отдельные методы. Упростите ветвления.',
  ],
  [
    'Extract common code into shared function or method. Reduce duplication to improve maintainability.',
    'Вынесите общее в одну функцию. Меньше копипасты — проще сопровождать.',
  ],
  ['Hardcoded secret', 'Секрет в коде'],
  ['Move the key to an environment variable.', 'Уберите ключ в переменную окружения.'],
  ['Move the key to env.', 'Уберите ключ в переменную окружения.'],
  ['Rotate the old one.', 'Старый ключ смените.'],
  ['Review and fix the identified vulnerability.', 'Разберите находку и закройте дыру.'],
  ['Embedded secrets are harvested from git and images.', 'Зашитые секреты легко достают из git и образов.'],
  ['Load secrets from a secret manager or runtime environment.', 'Секреты берите из секрет-хранилища или окружения рантайма.'],
  ['SQL injection can dump or mutate the entire database.', 'SQL-инъекция может слить или изменить всю базу.'],
  ['Use bound parameters / the ORM. Never concatenate SQL.', 'Используйте параметры или ORM. SQL строками не склеивайте.'],
  ['XSS can steal sessions or perform actions as the victim.', 'XSS может украсть сессию или выполнить действия от имени пользователя.'],
  ['Encode on output; avoid HTML sinks for untrusted data.', 'Экранируйте на выводе и не отправляйте недоверенные данные в HTML-sink.'],
  ['Command injection yields remote code execution on the application host.', 'Инъекция команды даёт удалённое выполнение кода на хосте приложения.'],
  ['Pass argument lists; never interpolate untrusted input into a shell.', 'Передавайте список аргументов и не подставляйте недоверенный ввод в shell.'],
  ['Sessions that never expire are stolen forever.', 'Сессию без срока жизни украдут навсегда.'],
  ['Rotate and expire server-side sessions.', 'Ротируйте токены и завершайте серверные сессии по сроку.'],
  ['Path traversal lets an attacker read or overwrite files outside the intended directory.', 'Обход пути позволяет читать или перезаписывать файлы вне разрешённой директории.'],
  ['Resolve against a jail directory and reject escapes.', 'Нормализуйте путь относительно корневой директории и отклоняйте выход за неё.'],
  ['Template/code injection can execute attacker-controlled code.', 'Инъекция в шаблон или код выполняет чужой код.'],
  ['Never render templates or evaluate code from request data.', 'Не рендерите шаблоны и не выполняйте код из данных запроса.'],
  ['Running as root/privileged expands blast radius after a breakout.', 'Запуск от root расширяет ущерб после взлома.'],
  ['Drop privileges and capabilities; run as a dedicated user.', 'Сбрасывайте привилегии и запускайте от отдельного пользователя.'],
  ['Hardcoded credentials are stolen with the repository.', 'Зашитые пароли уходят вместе с репозиторием.'],
  ['Load secrets from a secret manager or runtime environment.', 'Секреты берите из секрет-хранилища или окружения рантайма.'],
  ['Missing authorization lets any caller reach privileged operations.', 'Без авторизации любой вызывающий доберётся до привилегированных операций.'],
  ['Deny by default. Authorize on every object and route.', 'Запрещайте по умолчанию. Проверяйте права на каждый объект и маршрут.'],
  ['Weak authentication lets attackers impersonate users.', 'Слабая аутентификация позволяет выдавать себя за пользователя.'],
  ['Use proven auth libraries, brute-force controls, and verified recovery.', 'Используйте проверенные библиотеки, защиту от перебора и подтверждённое восстановление.'],
  ['Disabled TLS validation enables MITM.', 'Отключённая проверка TLS открывает MITM.'],
  ['Keep certificate verification enabled.', 'Не отключайте проверку сертификата.'],
  ['Missing brute-force controls make credential stuffing trivial.', 'Без защиты от перебора stuffing паролей становится тривиальным.'],
  ['Rate-limit and lock out authentication endpoints.', 'Ограничьте частоту и блокируйте эндпоинты входа.'],
  ['Unencrypted sensitive data is readable in transit or at rest.', 'Незашифрованные данные читают в транзите и на диске.'],
  ['Encrypt with authenticated encryption; never log secrets.', 'Шифруйте с аутентификацией и не пишите секреты в логи.'],
  ['Cleartext credentials travel on the network.', 'Пароли в открытом виде идут по сети.'],
  ['Use TLS and never put secrets in URLs.', 'Используйте TLS и не кладите секреты в URL.'],
  ['Predictable tokens can be guessed.', 'Предсказуемые токены можно угадать.'],
  ['Use a CSPRNG for security tokens.', 'Для токенов используйте криптостойкий ГПСЧ.'],
  ['Non-crypto PRNGs must not mint session or reset tokens.', 'Обычный ГПСЧ нельзя использовать для сессий и reset-токенов.'],
  ['Use secrets.token_urlsafe / crypto.getRandomValues.', 'Используйте secrets.token_urlsafe / crypto.getRandomValues.'],
  ['Unverified tokens can be forged.', 'Непроверенный токен можно подделать.'],
  ['Verify signatures, issuer, audience, and expiry.', 'Проверяйте подпись, issuer, audience и срок жизни.'],
  ['CSRF forges state-changing requests from the victim browser.', 'CSRF подделывает изменяющие запросы из браузера жертвы.'],
  ['Use SameSite cookies plus an anti-CSRF token.', 'Используйте SameSite и отдельный anti-CSRF токен.'],
  ['Races enable double-spend and duplicate side effects.', 'Гонки дают двойное списание и повторные побочные эффекты.'],
  ['Make mutations atomic and idempotent.', 'Делайте изменения атомарными и идемпотентными.'],
  ['Unbounded work is a denial of service.', 'Неограниченная работа — это отказ в обслуживании.'],
  ['Limit size, depth, batch, and time.', 'Ограничьте размер, глубину, пачку и время.'],
  ['Unrestricted uploads become webshells.', 'Неограниченная загрузка файлов превращается в webshell.'],
  ['Allowlist types by content, store outside the web root.', 'Разрешайте типы по содержимому и храните файлы вне web root.'],
  ['Unsafe deserialization is remote code execution.', 'Небезопасная десериализация — это удалённое выполнение кода.'],
  ['Prefer JSON. Never unpickle untrusted bytes.', 'Предпочитайте JSON. Не unpickle недоверенные байты.'],
  ['Weak password policy is brute-force friendly.', 'Слабая политика паролей упрощает перебор.'],
  ['Enforce length and a modern password KDF.', 'Требуйте длину и современный KDF для паролей.'],
  ['Open redirects are used in phishing.', 'Открытые редиректы используют в фишинге.'],
  ['Allow relative same-origin paths only.', 'Разрешайте только относительные пути того же origin.'],
  ['XXE reads local files or SSRFs the parser.', 'XXE читает локальные файлы или уводит парсер в SSRF.'],
  ['Disable external entities.', 'Отключите внешние сущности.'],
  ['IDOR / BOLA lets users access other people\'s objects.', 'IDOR / BOLA даёт доступ к чужим объектам.'],
  ['Authorize ownership/tenant on every object id.', 'Проверяйте владельца и тенанта на каждом id объекта.'],
  ['Allocation without limits exhausts the process.', 'Выделение без лимитов валит процесс.'],
  ['Cap uploads, queries, and concurrency.', 'Ограничьте загрузки, запросы и параллелизм.'],
  ['Rotate, purge history, inject at runtime.', 'Смените секреты, почистите историю, подставляйте в рантайме.'],
  ['Unpinned / untrusted components can be swapped for malware.', 'Незапиненные компоненты можно подменить вредоносом.'],
  ['Pin versions and verify integrity.', 'Фиксируйте версии и проверяйте целостность.'],
  ['Illegal state transitions skip approvals or payments.', 'Нелегальные переходы статусов обходят согласование и оплату.'],
  ['Enforce a server-side state machine.', 'Держите конечный автомат на сервере.'],
  ['Missing authorization on an API is a direct object/function leak.', 'API без авторизации сразу отдаёт объекты и функции.'],
  ['Bind authz to the operation, not the UI.', 'Вешайте авторизацию на операцию, не на UI.'],
  ['Incorrect authorization (BFLA) lets users call admin functions.', 'Неверная авторизация (BFLA) даёт вызывать админские функции.'],
  ['Map each handler to an explicit permission.', 'Каждому обработчику назначьте явное право.'],
  ['Mass assignment writes privileged fields from the client.', 'Mass assignment пишет привилегированные поля с клиента.'],
  ['Allowlist writable fields.', 'Разрешайте только безопасные поля для записи.'],
  ['SSRF reaches cloud metadata and internal services.', 'SSRF достаёт до cloud metadata и внутренних сервисов.'],
  ['Allowlist hosts; block link-local and RFC1918.', 'Разрешайте хосты явно; блокируйте link-local и RFC1918.'],
  ['Wildcard CORS with credentials leaks authenticated data.', 'CORS * с credentials утекает аутентифицированные данные.'],
  ['Allow explicit origins only.', 'Разрешайте только явные origin.'],
  ['Cookies without HttpOnly are stolen by XSS.', 'Cookie без HttpOnly крадёт XSS.'],
  ['Set HttpOnly, Secure, and strict SameSite.', 'Ставьте HttpOnly, Secure и строгий SameSite.'],
  ['Unmaintained dependencies keep known CVEs in production.', 'Заброшенные зависимости тащат известные CVE в прод.'],
  ['Keep a lockfile and fail CI on critical advisories.', 'Держите lockfile и валите CI на критичных advisory.'],
  ['Prototype pollution escalates into RCE in some stacks.', 'Prototype pollution в части стеков доходит до RCE.'],
  ['Prefer Map/null-prototype objects for user keys.', 'Для пользовательских ключей используйте Map или объекты без прототипа.'],
  ['SSTI executes attacker templates.', 'SSTI выполняет шаблоны атакующего.'],
  ['Never compile user-supplied templates.', 'Не компилируйте шаблоны из пользовательского ввода.'],
  ['Debug surfaces leak internals in production.', 'Отладочные поверхности светят внутренности на проде.'],
  ['Gate debug on environment.', 'Включайте debug только через окружение.'],
]

export function localizeFindingText(locale: Locale | string, text: string): string {
  if (locale !== 'ru' || !text) return text
  if (TITLES[text]) return TITLES[text]
  let out = text
  for (const [en, ru] of TITLE_PREFIXES) {
    const prefix = `${en}. `
    if (out.startsWith(prefix)) {
      out = `${ru}. ${out.slice(prefix.length)}`
      break
    }
  }
  for (const [pattern, repl] of REGEX) {
    out = out.replace(pattern, repl)
  }
  for (const [en, ru] of PHRASES) {
    if (out.includes(en)) out = out.split(en).join(ru)
  }
  return out
}
